module.exports = __webpack_public_path__ + "static/media/waves_5.c7ba48c5.jpg";